import { render, staticRenderFns } from "./CustomerQrcodeDownload.vue?vue&type=template&id=47246ead&"
import script from "./CustomerQrcodeDownload.vue?vue&type=script&lang=ts&"
export * from "./CustomerQrcodeDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports